export var unique = function () {
  return function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unique";
    return "".concat(prefix).concat(Math.floor(Date.now() / 1000), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
  };
}();